import { NextPageWithLayout } from '@src/pages/_app'
import Intro, { IntroProps } from '@src/services/mobility-bonus/intro/views'
import { MobilityBonusLayout } from '@src/services/mobility-bonus/shared/components/Layouts/MobilityBonusLayout'
import { isValidABTestId } from '@src/services/mobility-bonus/shared/utils/abTest/abTestUtils'
import { META } from '@src/shared/constants/meta'
import { withHeadTitle } from '@src/shared/hocs'
import { GetServerSidePropsContext } from 'next'

const Page: NextPageWithLayout<IntroProps> = withHeadTitle(
  ({ referralCode, abTestId }) => (
    <Intro referralCode={referralCode} abTestId={abTestId} />
  ),
  '바로 받는 이동지원금'
)

Page.getLayout = (page) => <MobilityBonusLayout>{page}</MobilityBonusLayout>

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { query, req } = context

  const fullUrl = `https://${req.headers.host}${req.url}`

  return {
    props: {
      referralCode: query.referralCode || '',
      allowZoom: true,
      abTestId: isValidABTestId(query.tid) ? query.tid : null,
      meta: {
        ...META,
        url: fullUrl,
      },
    },
  }
}

export default Page
